/// <reference path='../../interfaces/interfaces.d.ts' />

'use strict';


class EmployeeListController {
    public static $inject = [
        '$scope',
        '$state',
        'Employee',
        'User',
        'Orgs',
        'toaster',
        'bsLoadingOverlayService',
        '$uibModal'
    ];

    public employees = {
        loading: false,
        list: [],
        count: 0,
        query: ''
    };
    public pageNums;
    public maxPageItems = 20;
    public crtPage = 1;
    public user;
    public org;
    public hasPermission;
    public terminatedEmployees = [];
    public currentView = 'default';
    public loadingEmployees = false;
    public tempClearance = '';
    public availableViewOptions = [
        {value: 'default', name: 'Contact details'},
        {value: 'benefits', name: 'Salary & Benefits'},
        {value: 'employment', name: 'Employment Information'},
        {value: 'bank', name: 'Bank Information'},
        {value: 'leave', name: 'Leave'},
        {value: 'visa', name: 'Visa & EID'},
    ];

    public helpList = [false, false, false, false, false];
    public n: number = 0;
    public isHelping = false;
    public showOverlayCallOuts = false;
    public permissionLength;

    public test: boolean = true;
    public sortCol = 0;
    public sortDirFwd = true;
    private firstLoadFlag;      // used to prevent search filter from loading employees twice on first load
    private filterUpdateFlag = false;   // used to indicate if an employee load is because of a filter update

    public employee;

    // callouts
    public isCurrent = -1;
    public isTour;

    // for employee filters
    public isEmployeeView: Boolean;
    public employeeFilters: string;
    public all_offices: Array<any>;
    public all_divisions: Array<any>;
    public all_departments: Array<any>;
    public offices: Array<any>;
    public divisions: Array<any>;
    public departments: Array<any>;
    public current_office: string;
    public current_division: string;
    public current_department: string;

    constructor(private $scope: IEmpCtrlScope,
                private $state: ng.ui.IStateService,
                private Employee: IEmpService,
                private User: IUserService,
                private Orgs: IOrgsService,
                private toaster: toaster.IToasterService,
                private bsLoadingOverlayService: IBsLoadingService,
                private $uibModal: any) {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
        // clear the query on every page view
        this.Employee.setQuery('');
        $scope.employeeList = this.Employee.getObject();
        $scope.query = this.Employee.getQuery();
        $scope.filters_change_flag = this.Employee.filters_change_flag;

        this.listEmployees();
        // this.loadOrg();
        this.user = User;
        this.hasPermission = User.hasPermission;
        
        User.loadUser().then(response => {
            this.permissionLength = response.user.get_all_permissions.length;
        });

        let dereg: any = $scope.$watch('empList.employees.loading', (newVal) => {
            (newVal === true || newVal === undefined) 
                ? bsLoadingOverlayService.start({ referenceId: 'emplist_loading' }) 
                : bsLoadingOverlayService.stop({ referenceId: 'emplist_loading' });
        });

        $scope.$on('$destroy', () => {
            Employee.clean();
            dereg();
        });

        // check if filters are changed
        $scope.$watch('filters_change_flag.flag', (flag: string) => {
            // only update after first load
            if (this.firstLoadFlag) {
                this.filterUpdateFlag = true;
                this.listEmployees();
                $scope.$emit('$EL', 'employee.list.filter');
            }
        });

        $scope.$watch('query', _.debounce((term: string) => {
            this.Employee.setQuery(term);

            if (this.firstLoadFlag) {
                this.listEmployees();
                $scope.$emit('$EL', 'employee.list.search');
            } else {
                this.firstLoadFlag = true;
            }
            
        }, 500));

        Orgs.getOrgFromCache((response) => {
            this.org = response;
            // FIXME: Refactor this
            /*Employee.allNonEmployees(this.org.id).then(response => {
                for (let i: number = 0; i < response.length; i ++) {
                    if (response[i].active === false) {
                        this.terminatedEmployees.push(response[i]);
                    }
                }
            });
            Employee.allEmployees(this.org.id).then(response => {
                for (let i: number = 0; i < response.results.length; i ++) {
                    if (response.results[i].active === false) {
                        this.terminatedEmployees.push(response.results[i]);
                    }
                }
            });

             */
        });

        this.Employee.loadEmployee(User.getCurrentUser().userData.id).then((response: Restangular.IResponse) => {
            this.isTour = this.Employee.getCoTourStatus();
            let hasVisited: Boolean = false;
            this.employee = response;
            let list: any = this.employee.extra.help_boxes_visited;
            for (let i: any = 0; i < list.length; i++) {
                if (list[i] === 4) {
                    hasVisited = true;
                }
            }
            if (!hasVisited) {
                this.startCallouts();
            } else if (this.isTour === true) {
                this.startCallouts();
            }
        });
        
        this.isEmployeeView = (this.$state.current.url === '/employees') ? true : false;

        if (!this.User.getCurrentUser().userData.user.is_superuser) {
            this.Orgs.getOrgFromCache((org) => {
                this.org = org;
                if (!org.extra.offices) {
                    org.extra.offices = [];
                }
                this.all_offices = this.offices =  org.extra.offices;
                this.all_divisions = this.divisions = [].concat.apply([],
                    org.extra.offices.map((o) => {
                        if (o.divisions) {
                            o.divisions.map((d) => {
                                // d.display_name = o.name + ': ' + d.name;
                            });
                            return o.divisions;
                        } else {
                            return [];
                        }
                    }));
                this.all_departments = this.departments = [].concat.apply([],
                    org.extra.offices.map((o) => [].concat.apply([],
                        o.divisions ? o.divisions.map((d) => d.departments || []) : [])));
                this.isEmployeeView = true;
            });
        }

        $scope.$emit('$pageWithHelpVisited', 4);
    }

    public showDetails = (emp_id: any) => {
        this.$state.go('root.employees.details', { id: emp_id});
    }

    public setView(view: any): void {
        this.currentView = view;
        this.$scope.$emit('$EL', 'employee.list.view', view);

    }

    public getMoreData(): void {
        if (!this.pageNums) {
            return;
        }
        if (this.crtPage < this.pageNums.length) {
            this.listEmployees(this.crtPage + 1);
        }
    }

    public getFilters(): any {
        let filters: any = this.Employee.filters;
        let firstFilter: boolean = true;
        let filterText: string  = '';
        let finalText: any   = undefined;

        for (let filter in filters) {
            if (typeof filters[filter] === 'undefined') {
                continue;
            }
            if (typeof filters[filter] === 'object') {
                filterText = '';
                let l_filter: any = filters[filter];
                let first: boolean = true;
                for (let prop in l_filter) {
                    // make sure that this is not inherited properties
                    if (l_filter.hasOwnProperty(prop)) {
                        if (l_filter[prop]) {
                            if (first) {
                                first = false;
                            } else {
                                filterText += ', ';
                            }
                            filterText += prop;
                        }
                    }
                }
                // filterText = Object.keys(filters[filter]).join(', ')
            } else {
                filterText = filters[filter];
            }
            if (firstFilter) {
                finalText = filterText;
            } else {
                finalText += ', ' + filterText;
            }
            firstFilter = false;
        }

        if (finalText !== undefined && finalText.length > 30) {
            finalText = finalText.substring(0, 29) + '...';
        }

        if (finalText !== undefined) {
            this.employeeFilters = finalText.charAt(0).toUpperCase() + finalText.slice(1);
        } else {
            this.employeeFilters = finalText;
        }

        return this.Employee.filters;
    }

    public set_office (office: any): void {
        this.current_office = office;
        if (office) {
            office.divisions = office.divisions || [];
            this.divisions = office.divisions;
            this.departments = [].concat.apply([],
            office.divisions.map((d) => d.departments || []));

        } else {
            this.divisions = this.all_divisions;
            this.departments = this.all_departments;
        }

        this.$state.go('root.employees');
        let filters: any = angular.copy(this.Employee.getFilters());
        filters.office = this.mk_obj(office);
        filters.division = undefined;
        filters.department = undefined;
        this.Employee.setFilters(filters);
    }

    public set_division(division: any): void {
        this.current_division = division;

        if (division) {
            this.current_office = this.all_offices.filter((o) =>
                o.divisions ? o.divisions.filter((d) => d.name === division.name).length : 0
            )[0];
            this.departments = division.departments;
        } else {
            this.set_office(this.current_office);
        }

        this.$state.go('root.employees');
        let filters: any = angular.copy(this.Employee.getFilters());
        filters.office = this.mk_obj(this.current_office);
        filters.division = this.mk_obj(division);
        filters.department = undefined;
        this.Employee.setFilters(filters);
    }

    public set_department(department: any): void {
        this.current_department = department;
        if (department) {
            this.current_division = this.all_divisions.filter((d) =>
                d.departments ? d.departments.filter((d) => d.name === department.name).length : 0
            )[0];
            this.current_office = this.all_offices.filter((o) =>
                o.divisions ? o.divisions.filter((d) => d.name === this.current_division['name']).length : 0)[0];
        }

        this.$state.go('root.employees');
        let filters: any = angular.copy(this.Employee.getFilters());
        filters.office = this.mk_obj(this.current_office);
        filters.division = this.mk_obj(this.current_division);
        filters.department = this.mk_obj(department);
        this.Employee.setFilters(filters);
    }

    public mk_obj(item: any): any {
        let obj: any = {};
        if (item) {
            obj[item.name] = true;
        }
        return obj;
    }
    public openEmployeeFilter(): void {
        let modalInstance: any = this.$uibModal.open({
            controller: 'EmployeeFilterController as C',
            templateUrl: '/static/templates/modals/filterModal.html'
        });
    }

    public cleanFilters(): void {
        this.Employee.cleanFilters();
        this.divisions = this.all_divisions;
    }

    public listEmployees = function (page: number = 1): void {
        if (this.loadingEmployees) {
            return;
        }
        this.loadingEmployees = true;
        this.crtPage = page;
        this.bsLoadingOverlayService.start({ referenceId: 'emplist_loader' });
        let that: any = this;
        this.Employee.list('', page).then((response: Restangular.IResponse) => {
            this.loadingEmployees = false;
            let tmpEmployees: any = this.Employee.getObject();
            // if the search query is the same, this has been a next-page action and we should append the employees
            //  unless a filter update has taken place
            // console.log('tmpEmployees', this.Employee.getObject());
            if (this.employees.query === this.Employee.getQuery() && !that.filterUpdateFlag) {
                this.employees.list = this.employees.list.concat(tmpEmployees.list);
                this.employees.count = tmpEmployees.count;
            } else {
                // this has been a search query change or filter update, so make a new list
                that.filterUpdateFlag = false;
                this.employees.query = this.Employee.getQuery();
                this.employees.list = tmpEmployees.list;
                this.employees.count = tmpEmployees.count;
            }
            this.pageNums = new Array(Math.ceil(this.employees.count / this.maxPageItems));
            if (this.employees.count === 0) {
                this.toaster.pop('warning', 'Warning', 'No results matched the search term: ' + this.Employee.getQuery() + '. Please try to use a different keyword.');
            }
            this.bsLoadingOverlayService.stop({ referenceId: 'emplist_loader' });
        }).finally(() => {
            this.loadingEmployees = false;
        });
    };
    

    private loadOrg = function(): void {
        this.Orgs.getOrgFromCache((response) => {
            this.org = response;            
        });
    };

    public nextCallout (params: any): any {
        if (this.hasPermission(params)) {
        } else if (!this.hasPermission(params)) {
            this.isCurrent = this.isCurrent + 1;
        } else if (params === 'all') {
            this.isCurrent = this.isCurrent + 1;   
        }
    }

    public startCallouts = () => {
        if (this.isHelping) {
            if (this.isTour === true) {
                this.Employee.setCoTourStatus(false);
                this.isTour = this.Employee.getCoTourStatus();
            }
            this.isHelping = false;
            this.showOverlayCallOuts = false;
            this.isCurrent = -1;
        } else if (!this.isHelping) {
            this.isHelping = true;
            this.showOverlayCallOuts = true;
            this.isCurrent = 0;
        }
    }

    public nextTour = () => {
        this.$state.go('root.calendar');
    }

    public massInvite(): void {
        let modal_instance: any = this.$uibModal.open({
            controller: ['$scope', '$uibModalInstance', 'toaster', function ($scope: any, $uibModalInstance: any, toaster: any): void {
                $scope.confirmation = false;
                $scope.modalHeader = 'Mass Invitation';

                $scope.modalDetail = 'Message will be broadcasted.  Are you sure?';
                $scope.confirmButton = 'Send Mass Invite';
                $scope.cancelButton = 'Cancel';
                $scope.confirm = () => {
                    $scope.confirmation = true;
                    $uibModalInstance.close($scope.confirmation);
                };
                $scope.cancel = () => {
                    $scope.confirmation = false;
                    $uibModalInstance.close($scope.confirmation);
                };
            }],
            templateUrl: '/static/templates/modals/confirmation_modal.html'
        });

        modal_instance.result.then((selectedItem) => {
            this.org.sendMassInvites(selectedItem);
        });
    }

    public emitEvent(eventName: string, eventAddData?: string): void {
        this.$scope.$emit('$EL', eventName, eventAddData);
    }

}

angular.module('beneple.employees')
    .controller('EmployeeListController', EmployeeListController);



// WEBPACK FOOTER //
// ./frontend/scripts/employee/controllers/employee-list.controller.ts